<template>
  <div class="about min-vh-100 mx-auto">
      <div class="not-found text-center">
          <h1>404</h1>
          <h3>Page Not Found</h3>
          <a @click="$router.push({ name: 'Home' })" href="">Go Home</a>
      </div>
  </div>
</template>

<script>
export default {
  setup(){
    document.title = 'Page Not Found'
  }
}
</script>

<style scoped>
*{
  padding: 0;
  margin: 0;
}
h1{
  font-size: 9rem;
  color: #ff6600;
}
h3{
  font-size: 2rem;
  padding-bottom: 15px;
  color: #fff;
}
a{
  font-size: 1.5rem;
  color: #808080;
  cursor: pointer;
}
a:hover{
  color: blue;
  text-decoration: underline;
}
</style>